import { SimpleGrid } from '@/components/ui/lib/simple-grid';
import { Skeleton } from '@/components/ui/lib/skeleton';
import type { SkeletonCardGridProps } from '@/types/skeleton-card-grid';

/** A responsive grid of placeholder cards — the shape of a summary-tile row. */
const SkeletonCardGrid = ({ count, columns, height, gap = '3' }: SkeletonCardGridProps) => (
  <SimpleGrid columns={columns} gap={gap}>
    {Array.from({ length: count }, (_, index) => (
      <Skeleton key={index} height={height} rounded="2xl" />
    ))}
  </SimpleGrid>
);

export default SkeletonCardGrid;
